import React from "react";

export const inputCls = "w-full rounded-xl border-2 border-[#E2EBF0] px-3 py-2.5 text-sm focus:border-[#008057] outline-none bg-white";
export const cardCls = "rounded-2xl bg-white border border-[#E2EBF0] p-6 shadow-lg shadow-emerald-950/5";

export function Field({ label, children, required }) {
  return (
    <label className="block">
      <span className="text-sm font-semibold text-[#03281B]">{label}{required && <span className="text-red-500"> *</span>}</span>
      <div className="mt-1">{children}</div>
    </label>
  );
}

export function SelectField({ label, value, options, onChange, testid }) {
  return (
    <Field label={label} required>
      <select data-testid={testid} className={inputCls} value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="">Select</option>{options.map((s) => <option key={s} value={s}>{s}</option>)}
      </select>
    </Field>
  );
}
